/* db-max-scroll.js
   Homepage MAX collection row, mobile only (<=767px).

   The row stops being a carousel below 767px: the theme's carousel instance is
   parked on the element as el.flickityt4s and exposes destroy(), so it is torn
   down and the row becomes a plain native scroller. It then follows the finger
   exactly and coasts to a stop, with nothing animating to a fixed position.

   There are no arrows and no progress indicator. The only cue that the row
   slides is the next card cut by the screen edge, which is how Reels and most
   fashion sites do it. CSS owns the edge-to-edge layout.

   DESKTOP AND TABLET (>=768px): untouched. The carousel is never destroyed
   above 767px, and if the viewport crosses back up (a phone turned to
   landscape) the carousel is rebuilt from the theme's own constructor. */
(function () {
  var MQ = window.matchMedia('(max-width: 767px)');

  function init() {
    var sec = document.querySelector('[id*="__featured_collection_g8LH8h"]');
    if (!sec) return;
    var rail = sec.querySelector('.t4s-flicky-slider');
    if (!rail) return;

    /* clear anything earlier versions of this file left in the page */
    ['.db-maxstrip', '.db-maxrail'].forEach(function (sel) {
      var el = sec.querySelector(sel);
      if (el) el.parentNode.removeChild(el);
    });

    function toFree() {
      if (rail.classList.contains('db-free')) return;
      try {
        if (rail.flickityt4s && typeof rail.flickityt4s.destroy === 'function') {
          rail.flickityt4s.destroy();
          rail.flickityt4s = null;
        }
      } catch (e) { /* if it will not tear down, the CSS still scrolls */ }
      rail.classList.add('db-free');
    }

    function toCarousel() {
      if (!rail.classList.contains('db-free')) return;
      rail.classList.remove('db-free');
      try {
        if (!rail.flickityt4s && window.T4SThemeSP && window.T4SThemeSP.Carousel) {
          rail.flickityt4s = new window.T4SThemeSP.Carousel(rail);
        }
      } catch (e) { /* desktop styling does not depend on this */ }
    }

    function apply() { if (MQ.matches) { toFree(); } else { toCarousel(); } }

    var rt = null;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(apply, 150);
    }, { passive: true });
    if (MQ.addEventListener) MQ.addEventListener('change', apply);

    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 600); });
  } else {
    setTimeout(init, 600);
  }
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 500); });
})();
